/* Vanity Configurator — Blue Bathware
   Reads the product's native variants (Size / Colour / Benchtop) and the extras chosen in the theme editor.
   Every extra is a real product, added to the cart as its own line next to the vanity. */
(function () {
  'use strict';
  var X = '×', DOT = '·';

  function money(cents) {
    var n = cents / 100;
    return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function el(tag, attrs, html) {
    var e = document.createElement(tag); attrs = attrs || {};
    Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (k === 'class') e.className = v;
      else if (k.indexOf('on') === 0) e.addEventListener(k.slice(2), v);
      else if (v !== false && v != null) e.setAttribute(k, v);
    });
    if (html) e.innerHTML = html;
    return e;
  }
  /* Choice tiles are role="radio" divs, not <button>s. Meta Pixel's automatic events inspect every
     <button> click for ~0.4s, which made each pick lag and could lock the page. Keyboard works the same. */
  function choice(attrs, html) {
    var a = {}, checked = false, disabled = false, onclick = null;
    Object.keys(attrs).forEach(function (k) {
      if (k === 'aria-pressed') checked = attrs[k] === 'true' || attrs[k] === true;
      else if (k === 'disabled') disabled = !!attrs[k];
      else if (k === 'onclick') onclick = attrs[k];
      else if (k !== 'type') a[k] = attrs[k];
    });
    a.role = 'radio'; a['aria-checked'] = String(checked); a.tabindex = disabled ? '-1' : '0';
    if (disabled) a['aria-disabled'] = 'true';
    var e = el('div', a, html);
    if (onclick && !disabled) {
      e.addEventListener('click', onclick);
      e.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); onclick.call(e, ev); } });
    }
    return e;
  }
  function img(src, fallback, alt) {
    var fb = fallback ? ' onerror="this.onerror=null;this.src=\'' + esc(fallback) + '\'"' : '';
    return '<img loading="lazy" alt="' + esc(alt || '') + '" src="' + esc(src || fallback || '') + '"' + fb + '>';
  }
  function widthOf(s) { var m = String(s || '').match(/(\d{3,4})/); return m ? parseInt(m[1], 10) : 0; }
  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function optIndex(options, re) { for (var i = 0; i < options.length; i++) if (re.test(options[i])) return i; return -1; }
  function titleBase(t) { return String(t).split(' | ')[0].replace(/^Aulic\s+/i, ''); }
  function titleSize(t) { return String(t).split(' | ')[1] || ''; }

  /* Benchtop value -> { type, stone }. Unknown values become their own option. */
  var TYPES = {
    cabinet: { name: 'Cabinet only', sub: 'No benchtop or basin' },
    ceramic: { name: 'Ceramic top', sub: 'Ceramic top with moulded basin', tile: 'crystal-ceramic-top' },
    undermount: { name: 'Stone + undermount basin', sub: 'Basin fitted under the stone', tile: 'cato-undermount' },
    flat: { name: 'Flat stone top', sub: 'For an above-counter basin', tile: 'cato-flat' }
  };
  function parseTop(v) {
    if (!v) return { type: 'cabinet', stone: null };
    if (/cabinet only/i.test(v)) return { type: 'cabinet', stone: null };
    if (/ceramic/i.test(v)) return { type: 'ceramic', stone: 'Crystal' };
    if (/undermount/i.test(v)) return { type: 'undermount', stone: v.split(' ')[0] };
    if (/flat/i.test(v)) return { type: 'flat', stone: v.split(' ')[0] };
    return { type: 'other:' + v, stone: null };
  }
  var TAPS = [
    { k: '0', n: 'No tap hole', sub: 'Wall-mounted mixer', taps: [] },
    { k: '12', n: 'Tap hole at 12 o’clock', sub: 'Behind the basin', taps: [[0, -20]] },
    { k: '10', n: 'Tap hole at 10 o’clock', sub: 'Back left of the basin', taps: [[-16, -14]] },
    { k: '2', n: 'Tap hole at 2 o’clock', sub: 'Back right of the basin', taps: [[16, -14]] },
    { k: '10-2', n: '2 tap holes, 10 & 2 o’clock', sub: 'Separate hot and cold taps', taps: [[-16, -14], [16, -14]] }
  ];

  function Configurator(root) {
    this.root = root;
    this.D = JSON.parse(root.querySelector('[data-vc-data]').textContent);
    this.prepare();
    this.bind();
    this.render();
  }

  Configurator.prototype.prepare = function () {
    var D = this.D, P = D.product;
    var iSize = optIndex(P.options, /size|width/i), iCol = optIndex(P.options, /colou?r|finish/i), iTop = optIndex(P.options, /bench|top|config/i);
    this.vars = P.variants.map(function (v) {
      var o = {
        id: v.id, sku: v.sku, price: v.price, available: v.available, image: v.image, thumb: v.thumb,
        size: iSize > -1 ? v.options[iSize] : 'One size', colour: iCol > -1 ? v.options[iCol] : '', top: iTop > -1 ? v.options[iTop] : ''
      };
      var t = parseTop(o.top); o.type = t.type; o.stone = t.stone; return o;
    });
    this.sizes = [];
    this.vars.forEach(function (v) { if (this.sizes.indexOf(v.size) < 0) this.sizes.push(v.size); }, this);
    this.tileBase = D.settings.tileBase || '';

    /* basins: one design per product, finishes from its variants */
    this.basins = (D.basins || []).filter(function (p) { return !/wall hung/i.test(p.type + ' ' + p.title); }).map(function (p) {
      return {
        key: p.handle, name: titleBase(p.title).replace(/\s+(Above Counter|Semi[- ]Inset)\s+Basin.*$/i, ''),
        kind: /semi/i.test(p.type + ' ' + p.title) ? 'Semi-inset' : 'Above counter', size: titleSize(p.title),
        variants: p.variants.filter(function (v) { return v.available !== false; }).map(function (v) {
          return { id: v.id, sku: v.sku, finish: v.options[0] === 'Default Title' ? '' : v.options[0], price: v.price, compare: v.compare, image: v.image, title: p.title };
        })
      };
    }).filter(function (b) { return b.variants.length; });

    /* mirrors and shaving cabinets: grouped into designs with a width per variant */
    function looks(list, kind) {
      var groups = {};
      (list || []).forEach(function (p) {
        var led = /\bLED\b/.test(p.title);
        var base = titleBase(p.title).replace(/\s+LED\s+/i, ' ').replace(/\s+(Shaving Cabinet|Mirror Cabinet|Mirror)$/i, '').trim();
        var iS = optIndex(p.options, /size/i), iC = optIndex(p.options, /colou?r/i), iF = optIndex(p.options, /frame/i);
        var g = groups[base] || (groups[base] = { key: slug(base), name: base, variants: [] });
        p.variants.forEach(function (v) {
          if (v.available === false) return;
          var size = iS > -1 ? v.options[iS] : titleSize(p.title);
          var colour = iC > -1 ? v.options[iC] : '';
          var frame = iF > -1 ? v.options[iF] : '';
          var finish = kind === 'mirror' ? (frame || colour || v.title) : (colour + (frame && !/frameless/i.test(frame) ? ' ' + DOT + ' ' + frame + ' frame' : ''));
          g.variants.push({ id: v.id, sku: v.sku, size: size, width: widthOf(size), colour: colour, finish: finish || v.title, led: led, price: v.price, image: v.image, product: p.title });
        });
      });
      return Object.keys(groups).map(function (k) { return groups[k]; }).filter(function (g) { return g.variants.length; });
    }
    /* sort by product type, so a loose collection rule (e.g. "type contains LED Mirror") can't put cabinets under mirrors */
    function isCab(p) { return /cabinet/i.test((p.type || '') + ' ' + p.title); }
    this.look = {
      mirror: looks((D.mirrors || []).filter(function (p) { return !isCab(p); }), 'mirror'),
      cabinet: looks((D.cabinets || []).filter(isCab), 'cabinet')
    };
    var pw = (D.settings.picturedWith || '').toLowerCase();
    if (pw) this.look.mirror.sort(function (a, b) { return (b.name.toLowerCase().indexOf(pw) > -1) - (a.name.toLowerCase().indexOf(pw) > -1); });

    this.waste = D.waste ? D.waste.variants.filter(function (v) { return v.available !== false; }).map(function (v) {
      return { id: v.id, sku: v.sku, finish: v.title, price: v.price, image: v.image, product: D.waste.title };
    }) : [];
    function fee(p) { return p && p.variants[0] ? { id: p.variants[0].id, sku: p.variants[0].sku, price: p.variants[0].price, title: p.title } : null; }
    this.fees = { waste: fee(D.fees.waste), tap: fee(D.fees.tap), cutout: fee(D.fees.cutout) };
    this.canCut = !!(this.fees.waste && this.fees.tap);

    /* starting state from ?variant= or the first available variant */
    var vid = parseInt(new URLSearchParams(location.search).get('variant'), 10);
    var start = this.vars.filter(function (v) { return v.id === vid; })[0] || this.vars.filter(function (v) { return v.available; })[0] || this.vars[0];
    this.S = {
      size: start.size, colour: start.colour, type: start.type, stone: start.stone, view: null,
      waste: null, bdesign: null, basin: null, dmode: 'site', taps: '12',
      look: 'none', ldesign: null, lled: false, lsize: null, lsku: null, lfinish: null, lqty: null
    };
  };

  /* ---------- helpers ---------- */
  Configurator.prototype.q = function (sel) { return this.root.querySelector(sel); };
  Configurator.prototype.variantsFor = function (f) {
    return this.vars.filter(function (v) {
      return (!f.size || v.size === f.size) && (!f.colour || v.colour === f.colour) && (!f.type || v.type === f.type) && (!f.stone || v.stone === f.stone);
    });
  };
  Configurator.prototype.current = function () { var S = this.S; return this.variantsFor({ size: S.size, colour: S.colour, type: S.type, stone: S.stone })[0] || null; };
  function minPrice(list) { return list.length ? Math.min.apply(null, list.map(function (v) { return v.price; })) : 0; }
  function uniq(arr) { return arr.filter(function (x, i) { return arr.indexOf(x) === i; }); }
  Configurator.prototype.bowls = function () { return /double/i.test(this.S.size) ? 2 : 1; };
  Configurator.prototype.vw = function () { return widthOf(this.S.size); };
  Configurator.prototype.tile = function (key) { return this.tileBase ? this.tileBase + 'vc-top-' + key + '.jpg' : ''; };
  Configurator.prototype.tileFor = function (type, stone) {
    if (type === 'ceramic') return this.tile('crystal-ceramic-top');
    return this.tile(slug(stone || '') + '-' + (type === 'undermount' ? 'undermount' : 'flat'));
  };
  Configurator.prototype.cabThumb = function (size, colour) {
    var c = this.variantsFor({ size: size, colour: colour, type: 'cabinet' })[0] || this.variantsFor({ size: size, colour: colour })[0] || this.variantsFor({ size: size })[0];
    return c ? (c.thumb || c.image) : '';
  };
  Configurator.prototype.basinDesign = function () { var S = this.S; return this.basins.filter(function (b) { return b.key === S.bdesign; })[0] || null; };
  Configurator.prototype.basinItem = function () { var d = this.basinDesign(), S = this.S; return d ? d.variants.filter(function (v) { return v.sku === S.basin; })[0] : null; };
  Configurator.prototype.lookDesigns = function (kind) { var w = this.vw(); return this.look[kind].filter(function (d) { return d.variants.some(function (v) { return !v.width || v.width <= w; }); }); };
  Configurator.prototype.lookVariants = function () {
    var S = this.S, w = this.vw();
    var d = (this.look[S.look] || []).filter(function (x) { return x.key === S.ldesign; })[0];
    if (!d) return [];
    return d.variants.filter(function (v) { return (!v.width || v.width <= w) && (S.look !== 'cabinet' || v.led === S.lled); });
  };
  Configurator.prototype.maxQty = function (v) { return v && v.width && v.width * 2 <= this.vw() ? 2 : 1; };
  Configurator.prototype.lookItem = function () {
    var S = this.S; if (!S.look || S.look === 'none') return null;
    return this.lookVariants().filter(function (v) { return v.sku === S.lsku && v.finish === S.lfinish && v.size === S.lsize; })[0] || null;
  };

  /* ---------- state rules ---------- */
  Configurator.prototype.normalise = function () {
    var S = this.S, self = this;
    var colours = uniq(this.variantsFor({ size: S.size }).map(function (v) { return v.colour; }));
    if (colours.indexOf(S.colour) < 0) S.colour = colours[0];
    var types = uniq(this.variantsFor({ size: S.size, colour: S.colour }).map(function (v) { return v.type; }));
    if (types.indexOf(S.type) < 0) S.type = types.indexOf('undermount') > -1 ? 'undermount' : types[0];
    var stones = uniq(this.variantsFor({ size: S.size, colour: S.colour, type: S.type }).map(function (v) { return v.stone; }));
    if (stones.indexOf(S.stone) < 0) S.stone = stones[0];
    /* Extras that don't apply to the current top are parked, not thrown away, so comparing tops
       (flat -> ceramic -> flat, or -> cabinet only and back) brings the shopper's picks straight back. */
    if (S.type === 'cabinet') {
      if (S.waste) S._wasteMem = S.waste;
      S.waste = null;
    } else if (S._wasteMem) {
      if (!S.waste) S.waste = S._wasteMem;
      S._wasteMem = null;
    }
    if (S.type !== 'flat') {
      if (S.bdesign) S._basinMem = { bdesign: S.bdesign, basin: S.basin };
      S.bdesign = null; S.basin = null;
    } else if (S._basinMem) {
      if (!S.bdesign) { S.bdesign = S._basinMem.bdesign; S.basin = S._basinMem.basin; }
      S._basinMem = null;
    }
    var bd = this.basinDesign();
    if (bd && !bd.variants.some(function (v) { return v.sku === S.basin; })) S.basin = bd.variants[0].sku;
    if (bd && bd.kind === 'Semi-inset' && this.canCut) S.dmode = 'factory';
    if (!this.canCut) S.dmode = 'site';
    /* complete the look */
    if (S.look && S.look !== 'none') {
      var ds = this.lookDesigns(S.look);
      if (!ds.length) { S.look = 'none'; }
      else {
        if (!ds.some(function (x) { return x.key === S.ldesign; })) S.ldesign = ds[0].key;
        var d = ds.filter(function (x) { return x.key === S.ldesign; })[0];
        if (S.look === 'cabinet') {
          var leds = uniq(d.variants.map(function (v) { return v.led; }));
          if (leds.indexOf(S.lled) < 0) S.lled = leds.indexOf(false) > -1 ? false : leds[0];
        }
        var vs = this.lookVariants();
        var sizes = uniq(vs.map(function (v) { return v.size; }));
        if (sizes.indexOf(S.lsize) < 0) {
          /* wide wall cabinets default to the largest size that fits; mirrors to the first */
          var byW = sizes.slice().sort(function (a, b) { return widthOf(a) - widthOf(b); });
          S.lsize = sizes.length > 1 && widthOf(byW[byW.length - 1]) >= 600 ? byW[byW.length - 1] : sizes[0];
        }
        var pool = vs.filter(function (v) { return v.size === S.lsize; });
        if (!pool.some(function (v) { return v.sku === S.lsku && v.finish === S.lfinish; })) {
          var pick = pool.filter(function (v) { return v.finish === S.lfinish; })[0] || pool.filter(function (v) { return v.colour && v.colour === S.colour; })[0] || pool[0];
          S.lsku = pick.sku; S.lfinish = pick.finish;
        }
        var cur = pool.filter(function (v) { return v.sku === S.lsku && v.finish === S.lfinish; })[0];
        var mq = this.maxQty(cur);
        if (S.lqty == null || S.lqty > mq) S.lqty = Math.min(this.bowls(), mq);
      }
    }
    if (S.look === 'none') { S.ldesign = null; S.lsku = null; }
    void self;
  };

  /* ---------- rendering ---------- */
  Configurator.prototype.step = function (key, title, pick) {
    var s = el('div', { class: 'vc__step', 'data-step': key });
    s.appendChild(el('div', { class: 'vc__step-head' }, '<div class="vc__step-title"><span class="vc__num"></span>' + esc(title) + '</div><div class="vc__pick">' + (pick || '') + '</div>'));
    return s;
  };
  Configurator.prototype.opt = function (pressed, onclick, html, cls, disabled, key) {
    return choice({ class: 'vc__opt' + (cls ? ' ' + cls : ''), type: 'button', 'aria-pressed': String(!!pressed), disabled: !!disabled, 'data-k': key || null, onclick: onclick }, html);
  };

  Configurator.prototype.render = function () {
    var self = this, S = this.S;
    var active = document.activeElement && this.root.contains(document.activeElement) ? document.activeElement.getAttribute('data-k') : null;
    this.normalise();
    var steps = this.q('[data-vc-steps]'); steps.innerHTML = '';
    var set = function (patch) { return function () { Object.keys(patch).forEach(function (k) { S[k] = patch[k]; }); self.render(); }; };

    /* Size */
    if (this.sizes.length > 1) {
      var st = this.step('size', 'Size', '<b>' + esc(S.size) + '</b>'); var g = el('div', { class: 'vc__grid vc__grid--size' });
      this.sizes.forEach(function (sz) {
        var parts = sz.split(' '), w = parts.shift();
        g.appendChild(self.opt(S.size === sz, set({ size: sz, view: null, lqty: null }),
          '<span class="vc__ph vc__ph--contain">' + img(self.cabThumb(sz, S.colour)) + '</span><span class="vc__tx"><span class="vc__nm">' + esc(w) + '</span><span class="vc__sub">' + esc(parts.join(' ') || ' ') + '</span><span class="vc__px">from ' + money(minPrice(self.variantsFor({ size: sz }))) + '</span></span>', '', false, 'size:' + sz));
      });
      st.appendChild(g); steps.appendChild(st);
    }

    /* Colour (only when there is a choice) */
    var colours = uniq(this.variantsFor({ size: S.size }).map(function (v) { return v.colour; })).filter(Boolean);
    if (colours.length > 1) {
      var sc = this.step('colour', 'Cabinet colour', '<b>' + esc(S.colour) + '</b>'); var rw = el('div', { class: 'vc__swatches' });
      colours.forEach(function (c) {
        rw.appendChild(choice({ class: 'vc__swatch', type: 'button', title: c, 'aria-label': c, 'aria-pressed': String(S.colour === c), 'data-k': 'colour:' + c, onclick: set({ colour: c, view: null }) },
          '<span class="vc__swatch-crop" style="background-image:url(\'' + esc(self.cabThumb(S.size, c)) + '\')"></span><span class="vc__swatch-label">' + esc(c) + '</span>'));
      });
      sc.appendChild(rw); steps.appendChild(sc);
    }

    /* Benchtop type */
    var types = uniq(this.variantsFor({ size: S.size, colour: S.colour }).map(function (v) { return v.type; }));
    if (types.length > 1 || (types[0] && types[0] !== 'cabinet')) {
      var order = ['cabinet', 'ceramic', 'undermount', 'flat'].concat(types.filter(function (t) { return t.indexOf('other:') === 0; }));
      var base = minPrice(this.variantsFor({ size: S.size, colour: S.colour, type: 'cabinet' }));
      var stb = this.step('top', 'Benchtop', '<b>' + esc(TYPES[S.type] ? TYPES[S.type].name : S.type.slice(6)) + '</b>');
      var gt = el('div', { class: 'vc__grid vc__grid--top' });
      order.forEach(function (t) {
        var list = self.variantsFor({ size: S.size, colour: S.colour, type: t }); if (!list.length) return;
        var mp = minPrice(list), many = uniq(list.map(function (v) { return v.price; })).length > 1;
        var px = (t === 'cabinet' || !base) ? money(mp) : (many ? 'from ' : '') + '+ ' + money(mp - base);
        var name = TYPES[t] ? TYPES[t].name : t.slice(6), sub = TYPES[t] ? TYPES[t].sub : '';
        var pic = t === 'cabinet' ? '<span class="vc__ph vc__ph--contain">' + img(self.cabThumb(S.size, S.colour)) + '</span>'
          : '<span class="vc__ph">' + img(TYPES[t] ? self.tile(TYPES[t].tile) : '', list[0].thumb || list[0].image) + '</span>';
        gt.appendChild(self.opt(S.type === t, set({ type: t, view: null }), pic + '<span class="vc__tx"><span class="vc__nm">' + esc(name) + '</span><span class="vc__sub">' + esc(sub) + '</span><span class="vc__px">' + px + '</span></span>', '', false, 'top:' + t));
      });
      stb.appendChild(gt); steps.appendChild(stb);
    }

    /* Stone colour */
    if (S.type === 'undermount' || S.type === 'flat') {
      var list = this.variantsFor({ size: S.size, colour: S.colour, type: S.type }), lo = minPrice(list);
      var all = uniq(this.vars.filter(function (v) { return v.type === S.type; }).map(function (v) { return v.stone; }));
      var ss = this.step('stone', 'Stone colour', '<b>' + esc(S.stone) + '</b>'); var gs = el('div', { class: 'vc__grid vc__grid--stone' });
      all.forEach(function (stn) {
        var v = list.filter(function (x) { return x.stone === stn; })[0];
        gs.appendChild(self.opt(S.stone === stn, set({ stone: stn, view: null }),
          '<span class="vc__ph">' + img(self.tileFor(S.type, stn), v ? (v.thumb || v.image) : '') + '</span><span class="vc__tx"><span class="vc__nm">' + esc(stn) + '</span><span class="vc__px">' + (v ? (v.price > lo ? '+ ' + money(v.price - lo) : 'Included') : 'Not in this size') + '</span></span>', '', !v, 'stone:' + stn));
      });
      ss.appendChild(gs); steps.appendChild(ss);
    }

    this.renderExtras(steps, set);
    this.renderLook(steps, set);

    var n = 0; steps.querySelectorAll('.vc__num').forEach(function (e) { e.textContent = ++n; });
    this.renderGallery(); this.renderSummary();
    if (active) { var again = this.root.querySelector('[data-k="' + active.replace(/"/g, '\\"') + '"]'); if (again) again.focus({ preventScroll: true }); }
  };

  Configurator.prototype.grid = function (items, sel, qty, onPick, noneLabel, cls) {
    var self = this, g = el('div', { class: 'vc__grid ' + (cls || 'vc__grid--addon') });
    g.appendChild(this.opt(!sel, function () { onPick(null); }, '<span class="vc__ph vc__ph--none">No thanks</span><span class="vc__tx"><span class="vc__nm">' + esc(noneLabel) + '</span><span class="vc__px">$0</span></span>', 'vc__opt--none', false, 'none:' + noneLabel));
    items.forEach(function (a) {
      g.appendChild(self.opt(sel === a.id, function () { onPick(a.id); }, '<span class="vc__ph vc__ph--contain">' + img(a.image) + '</span><span class="vc__tx"><span class="vc__nm">' + esc(a.finish) + '</span><span class="vc__sub">' + esc(a.sku || '') + '</span><span class="vc__px">' + money(a.price) + (qty > 1 ? ' ' + X + ' ' + qty : '') + '</span></span>', '', false, 'add:' + a.id));
    });
    return g;
  };
  function tapIcon(t, b, semi) {
    var cx = b > 1 ? [30, 66] : [48];
    var s = '<svg width="84" height="58" viewBox="0 0 96 64" aria-hidden="true"><rect x="2" y="8" width="92" height="52" rx="2" fill="#f1ece4" stroke="#cfc5b6"/>';
    cx.forEach(function (x) {
      s += semi ? '<rect x="' + (x - (b > 1 ? 13 : 16)) + '" y="30" width="' + (b > 1 ? 26 : 32) + '" height="22" rx="6" fill="#fff" stroke="#415366" stroke-width="1.5"/>'
        : '<circle cx="' + x + '" cy="41" r="' + (b > 1 ? 9 : 11) + '" fill="#fff" stroke="#cfc5b6" stroke-dasharray="2 2"/><circle cx="' + x + '" cy="41" r="3.5" fill="#415366"/>';
      t.taps.forEach(function (p) { s += '<circle cx="' + (x + p[0] * (b > 1 ? 0.62 : 1)) + '" cy="' + (41 + p[1]) + '" r="3.2" fill="#415366"/>'; });
    });
    return s + '</svg>';
  }

  Configurator.prototype.renderExtras = function (steps, set) {
    var self = this, S = this.S, b = this.bowls();
    if (S.type === 'cabinet') {
      var sn = this.step('extras', 'Good to know', '');
      sn.appendChild(el('div', { class: 'vc__note' }, '<span class="vc__ic">i</span><span>Cabinet only comes without a benchtop or basin. Pick a benchtop above if you want the top supplied with the vanity.</span>'));
      steps.appendChild(sn); return;
    }
    var picks = [S.basin, S.type === 'flat' && S.dmode === 'factory', S.waste].filter(Boolean).length;
    var se = this.step('extras', S.type === 'flat' ? 'Basin, cutting & waste' : 'Pop-up waste', picks ? '<b>' + picks + ' added</b>' : 'Optional');

    if (S.type === 'flat') {
      if (this.basins.length) {
        var bb = el('div', { class: 'vc__sub-block' });
        bb.appendChild(el('div', { class: 'vc__sub-label' }, 'Basin <span>' + (b > 1 ? '2 basins for a double-bowl top' : 'Sits on the flat top') + '</span>'));
        var g = el('div', { class: 'vc__grid vc__grid--stone' });
        g.appendChild(this.opt(!S.bdesign, set({ bdesign: null, basin: null }), '<span class="vc__ph vc__ph--none">No thanks</span><span class="vc__tx"><span class="vc__nm">I’ll supply my own</span><span class="vc__px">$0</span></span>', 'vc__opt--none', false, 'basin:none'));
        this.basins.forEach(function (d) {
          var lo = minPrice(d.variants);
          g.appendChild(self.opt(S.bdesign === d.key, set({ bdesign: d.key, basin: null }),
            '<span class="vc__ph vc__ph--contain">' + (d.kind === 'Semi-inset' ? '<span class="vc__badge">Semi-inset</span>' : '') + img(d.variants[0].image) + '</span><span class="vc__tx"><span class="vc__nm">' + esc(d.name) + '</span><span class="vc__sub">' + esc(d.size) + '</span><span class="vc__px">from ' + money(lo) + '</span></span>', '', false, 'basin:' + d.key));
        });
        bb.appendChild(g);
        var d = this.basinDesign();
        if (d && d.variants.length > 1) {
          var cur = this.basinItem(), fb = el('div', { class: 'vc__sub-block' });
          fb.appendChild(el('div', { class: 'vc__sub-label' }, 'Finish <span>' + esc(cur.finish) + ' ' + DOT + ' ' + (cur.compare > cur.price ? '<s>' + money(cur.compare) + '</s> ' : '') + money(cur.price) + (b > 1 ? ' ' + X + ' 2' : '') + '</span>'));
          var fr = el('div', { class: 'vc__frames' });
          d.variants.forEach(function (v) { fr.appendChild(choice({ class: 'vc__frame', type: 'button', 'aria-pressed': String(S.basin === v.sku), 'data-k': 'bfin:' + v.sku, onclick: set({ basin: v.sku }) }, img(v.image) + '<span>' + esc(v.finish) + '</span>')); });
          fb.appendChild(fr); bb.appendChild(fb);
        }
        se.appendChild(bb);
      }
      /* stone cutting */
      var semi = !!(this.basinDesign() && this.basinDesign().kind === 'Semi-inset');
      var cb = el('div', { class: 'vc__sub-block' });
      /* two plain questions: 1) who makes the basin hole, 2) if we do, where the tap holes go.
         Each tile shows only its own cost, so nobody has to work out what is bundled into what. */
      var holeName = semi ? 'basin cut-out' : 'waste hole';
      var perBasin = b > 1 ? ' each basin' : '';
      cb.appendChild(el('div', { class: 'vc__sub-label' }, (semi ? 'Basin cut-out' : 'Basin waste hole') + ' <span>Flat stone tops arrive uncut</span>'));
      var cg = el('div', { class: 'vc__grid vc__grid--wide' });
      cg.appendChild(this.opt(S.dmode === 'site', set({ dmode: 'site' }),
        '<span class="vc__ph vc__ph--icon">' + tapIcon({ taps: [] }, b, false) + '</span><span class="vc__tx"><span class="vc__nm">I’ll drill it on site</span><span class="vc__sub">' + (semi ? 'Not possible for a semi-inset basin, it needs a factory cut-out' : 'Free 35mm and 80mm drill bits come with the top') + '</span><span class="vc__px">$0</span></span>', 'vc__opt--wide', semi, 'cut:site'));
      if (this.canCut) {
        var holeFee = semi && this.fees.cutout ? this.fees.cutout.price : this.fees.waste.price;
        cg.appendChild(this.opt(S.dmode === 'factory', set({ dmode: 'factory' }),
          '<span class="vc__ph vc__ph--icon">' + tapIcon({ taps: [] }, b, semi) + '</span><span class="vc__tx"><span class="vc__nm">Cut it for me before dispatch</span><span class="vc__sub">We cut the ' + holeName + perBasin + ', then you choose tap holes below</span><span class="vc__px">' + money(holeFee * b) + '</span></span>', 'vc__opt--wide', false, 'cut:factory'));
      }
      cb.appendChild(cg);
      se.appendChild(cb);
      if (S.dmode === 'factory' && this.canCut) {
        var tb = el('div', { class: 'vc__sub-block' });
        tb.appendChild(el('div', { class: 'vc__sub-label' }, 'Tap holes <span>' + money(this.fees.tap.price) + ' per hole' + (b > 1 ? ', per basin' : '') + '</span>'));
        var tg = el('div', { class: 'vc__grid vc__grid--stone' });
        TAPS.forEach(function (t) {
          var n = t.taps.length, px = n ? '+ ' + money(self.fees.tap.price * n * b) : 'No extra';
          tg.appendChild(self.opt(S.taps === t.k, set({ taps: t.k }), '<span class="vc__ph vc__ph--icon vc__ph--43">' + tapIcon(t, b, semi) + '</span><span class="vc__tx"><span class="vc__nm">' + esc(t.n) + '</span><span class="vc__sub">' + esc(t.sub) + '</span><span class="vc__px">' + px + '</span></span>', '', false, 'tap:' + t.k));
        });
        tb.appendChild(tg);
        tb.appendChild(el('div', { class: 'vc__hint' }, 'Custom cuts can’t be returned or exchanged. Extra lead time may apply.'));
        se.appendChild(tb);
      }
    }
    if (this.waste.length) {
      var wb = el('div', { class: 'vc__sub-block' });
      wb.appendChild(el('div', { class: 'vc__sub-label' }, 'Pop-up waste <span>' + (b > 1 ? '2 needed for a double bowl' : 'Not included with the vanity') + '</span>'));
      wb.appendChild(this.grid(this.waste, S.waste, b, function (id) { S.waste = id; self.render(); }, 'Not now'));
      se.appendChild(wb);
    }
    steps.appendChild(se);
  };

  Configurator.prototype.renderLook = function (steps, set) {
    var self = this, S = this.S;
    var kinds = ['mirror', 'cabinet'].filter(function (k) { return self.lookDesigns(k).length; });
    if (!kinds.length) return;
    var li = this.lookItem(), d0 = li && this.look[S.look].filter(function (x) { return x.key === S.ldesign; })[0];
    var sl = this.step('look', 'Complete the look', li ? '<b>' + esc(d0.name) + (S.lqty > 1 ? ' ' + X + ' 2' : '') + '</b>' : 'Optional');
    var LOOK = { mirror: ['LED mirror', 'Backlit with demister'], cabinet: ['Shaving cabinet', 'Mirror with storage behind'] };
    var g = el('div', { class: 'vc__grid vc__grid--choice' });
    kinds.forEach(function (k) {
      var ds = self.lookDesigns(k), w = self.vw();
      var vs = [].concat.apply([], ds.map(function (d) { return d.variants.filter(function (v) { return !v.width || v.width <= w; }); }));
      var rep = vs.filter(function (v) { return /frameless|matte white/i.test(v.finish); })[0] || vs[0];
      g.appendChild(self.opt(S.look === k, set({ look: k, lqty: null }), '<span class="vc__ph">' + img(rep.image) + '</span><span class="vc__tx"><span class="vc__nm">' + LOOK[k][0] + '</span><span class="vc__sub">' + LOOK[k][1] + '</span><span class="vc__px">from ' + money(minPrice(vs)) + '</span></span>', '', false, 'look:' + k));
    });
    g.appendChild(this.opt(!S.look || S.look === 'none', set({ look: 'none' }), '<span class="vc__ph vc__ph--none">No thanks</span><span class="vc__tx"><span class="vc__nm">No thanks</span><span class="vc__sub">Just the vanity</span><span class="vc__px">$0</span></span>', 'vc__opt--none', false, 'look:none'));
    sl.appendChild(g);

    if (S.look && S.look !== 'none') {
      var w = this.vw(), ds = this.lookDesigns(S.look), pw = (this.D.settings.picturedWith || '').toLowerCase();
      var b1 = el('div', { class: 'vc__sub-block' });
      b1.appendChild(el('div', { class: 'vc__sub-label' }, 'Design <span>' + ds.length + ' suit a ' + w + 'mm vanity</span>'));
      var g1 = el('div', { class: 'vc__grid vc__grid--stone' });
      ds.forEach(function (d) {
        var fit = d.variants.filter(function (v) { return !v.width || v.width <= w; });
        var rep = fit.filter(function (v) { return /frameless/i.test(v.finish); })[0] || fit.filter(function (v) { return /matte white/i.test(v.finish); })[0] || fit[0];
        var badge = S.look === 'mirror' && pw && d.name.toLowerCase().indexOf(pw) > -1 ? '<span class="vc__badge">As pictured</span>' : '';
        g1.appendChild(self.opt(S.ldesign === d.key, set({ ldesign: d.key, lqty: null, lsize: null }), '<span class="vc__ph">' + badge + img(rep.image) + '</span><span class="vc__tx"><span class="vc__nm">' + esc(d.name) + '</span><span class="vc__sub">' + esc(uniq(fit.map(function (v) { return v.size; })).join(' / ')) + '</span><span class="vc__px">from ' + money(minPrice(fit)) + '</span></span>', '', false, 'ld:' + d.key));
      });
      b1.appendChild(g1); sl.appendChild(b1);
      var d = ds.filter(function (x) { return x.key === S.ldesign; })[0];
      if (S.look === 'cabinet') {
        var leds = uniq(d.variants.map(function (v) { return v.led; }));
        if (leds.length > 1) {
          var bl = el('div', { class: 'vc__sub-block' }); bl.appendChild(el('div', { class: 'vc__sub-label' }, 'Lighting'));
          var qq = el('div', { class: 'vc__seg' });
          [[false, 'Standard'], [true, 'With LED lighting']].forEach(function (p) {
            var lo = minPrice(d.variants.filter(function (v) { return v.led === p[0]; }));
            qq.appendChild(choice({ type: 'button', 'aria-pressed': String(S.lled === p[0]), 'data-k': 'led:' + p[0], onclick: set({ lled: p[0] }) }, p[1] + ' ' + DOT + ' from ' + money(lo)));
          });
          bl.appendChild(qq); sl.appendChild(bl);
        }
      }
      var vs = this.lookVariants(), sizes = uniq(vs.map(function (v) { return v.size; }));
      if (sizes.length > 1) {
        var bs = el('div', { class: 'vc__sub-block' }); bs.appendChild(el('div', { class: 'vc__sub-label' }, 'Size'));
        var sq = el('div', { class: 'vc__seg' });
        sizes.forEach(function (s) { sq.appendChild(choice({ type: 'button', 'aria-pressed': String(S.lsize === s), 'data-k': 'lsize:' + s, onclick: set({ lsize: s, lqty: null }) }, esc(s) + ' ' + DOT + ' ' + money(minPrice(vs.filter(function (v) { return v.size === s; }))))); });
        bs.appendChild(sq); sl.appendChild(bs);
      }
      var pool = vs.filter(function (v) { return v.size === S.lsize; });
      var cur = pool.filter(function (v) { return v.sku === S.lsku && v.finish === S.lfinish; })[0];
      if (cur) {
        var bf = el('div', { class: 'vc__sub-block' });
        bf.appendChild(el('div', { class: 'vc__sub-label' }, (S.look === 'cabinet' ? 'Colour' : 'Frame') + ' <span>' + esc(cur.finish) + ' ' + DOT + ' ' + money(cur.price) + '</span>'));
        var fr = el('div', { class: 'vc__frames' });
        pool.forEach(function (v) {
          var match = S.look === 'cabinet' && v.colour && v.colour === S.colour;
          fr.appendChild(choice({ class: 'vc__frame', type: 'button', title: v.finish, 'aria-pressed': String(v.sku === S.lsku && v.finish === S.lfinish), 'data-k': 'lf:' + v.sku + v.finish, onclick: set({ lsku: v.sku, lfinish: v.finish }) }, img(v.image) + '<span>' + esc(v.finish) + '</span>' + (match ? '<em>Matches vanity</em>' : '')));
        });
        bf.appendChild(fr); sl.appendChild(bf);
        if (this.maxQty(cur) > 1) {
          var bq = el('div', { class: 'vc__sub-block' });
          bq.appendChild(el('div', { class: 'vc__sub-label' }, 'How many <span>' + (this.bowls() > 1 ? 'One above each basin' : 'Two side by side also fit') + '</span>'));
          var q2 = el('div', { class: 'vc__seg' });
          [1, 2].forEach(function (n) { q2.appendChild(choice({ type: 'button', 'aria-pressed': String(S.lqty === n), 'data-k': 'lqty:' + n, onclick: set({ lqty: n }) }, String(n))); });
          bq.appendChild(q2); sl.appendChild(bq);
        }
      }
    }
    steps.appendChild(sl);
  };

  Configurator.prototype.renderGallery = function () {
    var self = this, S = this.S, v = this.current(); if (!v) return;
    var w = this.vw(), media = this.D.product.media;
    var main = { src: v.image || (media[0] && media[0].src), thumb: v.thumb || v.image, alt: v.top };
    var related = media.filter(function (m) { var mm = (m.alt || '').match(/(\d{3,4})mm/); return !mm || parseInt(mm[1], 10) === w; });
    var list = [main].concat(related).filter(function (m, i, a) { return m.src && a.map(function (x) { return x.src.split('?')[0]; }).indexOf(m.src.split('?')[0]) === i; }).slice(0, 10);
    if (!S.view || !list.some(function (m) { return m.src === S.view; })) S.view = list[0] && list[0].src;
    var mainEl = this.q('[data-vc-main]'); if (S.view && mainEl.getAttribute('src') !== S.view) { mainEl.src = S.view; }
    mainEl.alt = this.D.product.title + ' ' + S.size + ' ' + (v.top || '');
    var th = this.q('[data-vc-thumbs]'); th.innerHTML = '';
    list.forEach(function (m) { th.appendChild(choice({ type: 'button', 'aria-pressed': String(S.view === m.src), 'aria-label': 'Show image', onclick: function () { S.view = m.src; self.renderGallery(); } }, img(m.thumb || m.src, null, m.alt))); });
    var inset = this.q('[data-vc-inset]'); inset.innerHTML = '';
    function chip(src, fb, small, txt) { inset.appendChild(el('div', { class: 'vc__chip' }, img(src, fb) + '<span><small>' + small + '</small>' + esc(txt) + '</span>')); }
    if (S.type === 'undermount' || S.type === 'flat' || S.type === 'ceramic') chip(this.tileFor(S.type, S.stone), v.thumb, 'Your top', S.type === 'ceramic' ? 'Ceramic top' : S.stone + (S.type === 'undermount' ? ' + undermount basin' : ' flat stone'));
    var bi = this.basinItem(); if (bi) chip(bi.image, null, 'Your basin' + (this.bowls() > 1 ? 's' : ''), this.basinDesign().name + (bi.finish ? ' ' + DOT + ' ' + bi.finish : ''));
    var li = this.lookItem(); if (li) { var d = this.look[S.look].filter(function (x) { return x.key === S.ldesign; })[0]; chip(li.image, null, 'Your ' + (S.look === 'cabinet' ? 'cabinet' : 'mirror') + (S.lqty > 1 ? 's' : ''), d.name + ' ' + DOT + ' ' + li.finish + (S.lqty > 1 ? ' ' + X + ' 2' : '')); }
  };

  Configurator.prototype.lines = function () {
    var S = this.S, v = this.current(), b = this.bowls(), L = [];
    if (!v) return L;
    var tap = TAPS.filter(function (t) { return t.k === S.taps; })[0];
    var props = { _vanity_build: v.sku };
    if (S.type === 'flat') props['Stone cutting'] = S.dmode === 'factory' && this.canCut ? tap.n : 'Customer drills on site';
    L.push({ name: this.D.product.title + ' ' + DOT + ' ' + S.size, sub: [v.sku, v.colour, v.top].filter(Boolean).join(' ' + DOT + ' '), price: v.price, qty: 1, id: v.id, props: props });
    var bi = this.basinItem();
    if (bi) L.push({ name: bi.title.split(' | ')[0] + (bi.finish ? ' ' + DOT + ' ' + bi.finish : ''), sub: bi.sku + ' ' + X + ' ' + b, price: bi.price * b, qty: b, id: bi.id });
    if (S.type === 'flat' && S.dmode === 'factory' && this.canCut) {
      var semi = this.basinDesign() && this.basinDesign().kind === 'Semi-inset' && this.fees.cutout;
      var f = semi ? this.fees.cutout : this.fees.waste;
      L.push({ name: f.title.replace(/^Aulic\s+/i, '').replace(' | ', ' — '), sub: f.sku + ' ' + X + ' ' + b, price: f.price * b, qty: b, id: f.id });
      if (tap.taps.length) L.push({ name: this.fees.tap.title.replace(/^Aulic\s+/i, '').replace(' | ', ' — '), sub: this.fees.tap.sku + ' ' + X + ' ' + tap.taps.length * b + ' ' + DOT + ' ' + tap.n, price: this.fees.tap.price * tap.taps.length * b, qty: tap.taps.length * b, id: this.fees.tap.id });
    }
    var w = this.waste.filter(function (x) { return x.id === S.waste; })[0];
    if (w) L.push({ name: w.product.split(' | ')[0].replace(/^Fienza\s*-\s*/i, 'Fienza ') + ' ' + DOT + ' ' + w.finish, sub: w.sku + ' ' + X + ' ' + b, price: w.price * b, qty: b, id: w.id });
    var li = this.lookItem();
    if (li) L.push({ name: li.product.split(' | ')[0] + ' ' + DOT + ' ' + li.finish, sub: li.sku + ' ' + DOT + ' ' + li.size + ' ' + X + ' ' + S.lqty, price: li.price * S.lqty, qty: S.lqty, id: li.id });
    return L;
  };

  Configurator.prototype.renderSummary = function () {
    var S = this.S, v = this.current(); if (!v) return;
    var L = this.lines(), tot = L.reduce(function (s, l) { return s + l.price; }, 0);
    /* price and SKU are optional blocks now, so only update them when they are on the page */
    var priceEl = this.q('[data-vc-price]'), skuEl = this.q('[data-vc-sku]');
    if (priceEl) priceEl.textContent = money(v.price);
    if (skuEl) skuEl.textContent = 'SKU ' + v.sku;
    this.q('[data-vc-lines]').innerHTML = L.map(function (l) {
      var extra = l.props && l.props['Stone cutting'] ? ' ' + DOT + ' ' + esc(l.props['Stone cutting']) : '';
      return '<li><span class="vc__l-n">' + esc(l.name) + '</span><span class="vc__l-p">' + money(l.price) + '</span><span class="vc__l-s">' + esc(l.sub) + extra + '</span></li>';
    }).join('');
    this.q('[data-vc-total]').textContent = money(tot);
    /* keep Afterpay (and any other payment-messaging widget) on the whole build, not the 600mm cabinet it loaded with */
    var amt = (tot / 100).toFixed(2);
    this.root.querySelectorAll('square-placement, afterpay-placement').forEach(function (el) {
      if (el.getAttribute('data-amount') !== amt) el.setAttribute('data-amount', amt);
    });
    this.q('[data-vc-mtotal]').textContent = money(tot);
    this.q('[data-vc-msel]').textContent = S.size + ' ' + DOT + ' ' + (TYPES[S.type] ? (S.type === 'undermount' || S.type === 'flat' ? S.stone + ' ' + (S.type === 'flat' ? 'flat top' : 'undermount') : TYPES[S.type].name) : S.type.slice(6));
    var idInput = this.q('[data-vc-id]');
    if (idInput && String(idInput.value) !== String(v.id)) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
    var addBtns = this.root.querySelectorAll('[data-vc-add]');
    addBtns.forEach(function (bt) { bt.disabled = !v.available; bt.textContent = v.available ? 'Add to cart' : 'Sold out'; });
    this.syncUrl(v.id);
  };

  /* Keep ?variant= in the address bar for sharing, but only once the shopper pauses.
     Other scripts on the live site wrap history.replaceState and take ~0.5s per call,
     so calling it on every click made the page lag and could lock it up. */
  Configurator.prototype.syncUrl = function (id) {
    clearTimeout(this._urlTimer);
    this._urlTimer = setTimeout(function () {
      try {
        var u = new URL(location.href);
        if (u.searchParams.get('variant') === String(id)) return;
        u.searchParams.set('variant', id);
        var go = function () { history.replaceState(history.state, '', u.toString()); };
        if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 2000 }); else go();
      } catch (e) { /* ignore */ }
    }, 900);
  };

  Configurator.prototype.bind = function () {
    var self = this;
    this.root.querySelectorAll('[data-vc-add]').forEach(function (bt) { bt.addEventListener('click', function () { self.add(); }); });
  };

  Configurator.prototype.add = function () {
    var self = this, L = this.lines(), msg = this.q('[data-vc-msg]');
    var parent = this.D.product.title + ' ' + this.S.size;
    var items = L.map(function (l, i) {
      var p = Object.assign({}, l.props || {});
      if (i > 0) p._vanity_part_of = parent;
      return { id: l.id, quantity: l.qty, properties: p };
    });
    var btns = this.root.querySelectorAll('[data-vc-add]');
    btns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Something went wrong');
        if (self.D.settings.afterAdd === 'cart') { location.href = root + 'cart'; return; }
        msg.textContent = 'Added ' + L.length + ' item' + (L.length > 1 ? 's' : '') + ' to your cart.';
        document.dispatchEvent(new CustomEvent('vc:added', { detail: { items: items } }));
      })
      .catch(function (e) { msg.textContent = 'Couldn’t add to cart: ' + e.message + '. Please try again or call us.'; })
      .then(function () { btns.forEach(function (b) { b.disabled = false; b.textContent = 'Add to cart'; }); });
  };

  function boot() { document.querySelectorAll('[data-vc-section]').forEach(function (r) { if (!r.__vc) r.__vc = new Configurator(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
